
          import "Slider.styles_3wjqq9.linaria.css";
          import { styled } from "@linaria/react";
import { focusStyle, typeStyle } from "@carvana/showroom-css-theme";
import Input from "../Input";
export const SliderOuterWrapper = /*#__PURE__*/styled("div")({
  name: "SliderOuterWrapper",
  class: "s170f405"
});
export const Handle = /*#__PURE__*/styled("div")({
  name: "Handle",
  class: "hm0nuvw"
});
export const SliderData = /*#__PURE__*/styled("div")({
  name: "SliderData",
  class: "se5ealo"
});
export const ValueInput = /*#__PURE__*/styled(Input)({
  name: "ValueInput",
  class: "vr5sy8d"
});
          